<template>
  <div class="group-box">
    <div class="tea-group">
      <div class="group-main">
        <div class="group-list">
          <el-card class="box-card" v-for="(item,index) in group_list" :key="index">
            <div class="card-main">
              <!-- 小组名称 -->
              <div class="group-name">
                <img :src="item.tx" alt="" v-if='item.tx' class="group-name-img">
                <el-avatar icon="el-icon-user-solid" v-else></el-avatar>
                <span style="margin-left:10px">{{item.mc}}</span>
              </div>
              <!-- 小组编号小组人数 -->
              <div class="group-num">
                <span>小组编号：{{item.id}}</span>
                <span>小组人数：{{item.rs}}</span>
              </div>
              <!-- 创建时间 -->
              <div class="group-time">创建时间：{{item.cjrqTwo}}</div>
              <!-- 小组成员 -->
              <div class="group-people">
                <div class="people-title" style="width:70px">小组成员：</div>
                <div class="people-list">
                  <el-tag size="mini" style="margin:0 5px" v-for="(itm,inx) in item.classGroupStudentList" :key="inx">{{itm.xsmc}}</el-tag>
                </div>
              </div>
            </div>
            <div class="card-btn" v-show="tab_pane_index==2">
              <div class="btn">
                <el-button type="text" style="color:#409EFF" @click="editGroup(2,item)" :disabled='class_type==1'>编辑小组</el-button>
              </div>
              <div class="btn">
                <el-button type="text" style="color:#F56C6C" @click="delGroup(item)" :disabled='class_type==1'>删除小组</el-button>
              </div>
            </div>
          </el-card>
        </div>
      </div>
      <div class="tea-pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pages.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pages.total">
        </el-pagination>
      </div>
    </div>
    <!-- 新增分组 -->
    <el-dialog :title="edit_group_obj.title" :visible.sync="edit_group_obj.dialogVisible" width='700px' :modal-append-to-body="true" class="tea-diolag">
      <div class="group-main">
        <el-form label-width="100px" class="demo-form-inline" :inline="true">
          <el-form-item label="小组名称：" required>
            <el-input placeholder="请填写小组名称" v-model="edit_group_obj.model.mc"></el-input>
          </el-form-item>
          <el-form-item label="小组人数：" required>
            <el-input placeholder="请设置小组人数" type="number" v-model="edit_group_obj.model.rs"></el-input>
          </el-form-item>
          <el-form-item label="用户头像：">
            <el-upload class="avatar-uploader" :action="action" :data="fileData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" ref="upload">
              <div class="header-box">
                <el-image style="width: 100%; height: 100%" fit='cover' class="el-image" :src="edit_group_obj.model.tx" v-show="edit_group_obj.model.tx"></el-image>
                <i class="el-icon-plus avatar-uploader-icon" v-show="!edit_group_obj.model.tx"></i>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="小组成员：" required style="width:100%">
            <div class="is-full" v-show="default_checked_keys.length >=edit_group_obj.model.rs"><span>该小组人数已满</span></div>
            <div class="select-box">
              <el-card class="student-list">
                <div slot="header" class="clearfix">
                  <span>未分组学生</span>
                </div>
                <el-checkbox-group v-model="default_checked_keys" @change="nodeClick" :disabled="default_checked_keys.length >=edit_group_obj.model.rs">
                  <el-checkbox v-for="item in student_list_tree" :label="item.xsid" :key="item.xsid">{{item.xsmc}}</el-checkbox>
                </el-checkbox-group>
              </el-card>
              <el-card class="student-select">
                <div slot="header" class="clearfix">
                  <span>已选择学生</span>
                </div>
                <el-tag class="el-tag" :key="index" v-for="(item,index) in student_select_list" closable :disable-transitions="false" @close="handleClose(item,index)">
                  {{item.xsmc}}
                </el-tag>
              </el-card>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="edit_group_obj.dialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="submitGroupStudent()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 学生随机分组 -->
    <el-dialog :title="random_group_obj.title" :visible.sync="random_group_obj.dialogVisible" width='400px' :modal-append-to-body="true" class="tea-diolag">
      <div class="group-main">
        <el-form label-width="100px" class="demo-form-inline" :inline="true">
          <el-form-item label="小组个数：" required>
            <el-input placeholder="请填写小组个数" type="number" v-model="random_group_obj.model.count"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="random_group_obj.dialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="randomGroupSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  studentGroupListApi,//小组list
  studentGroupHistoryListApi,//历史小组list
  uploadFile,//上传文件
  studentNoSelectApi,//未选择的学生
  creatGroupAddApi,//创建班级小组
  creatGroupEditApi,//修改班级小组
  creatGroupGandomApi,//随机创建班级小组
  classGroupInforApi,//查看班级小组
  classGroupDelApi,// 删除小组

} from '@/api/teacher'
export default {
  props: {
    tab_pane_index: {
      default: 2,
    },
    class_type: {
      default: 0,
    },
  },
  data() {
    return {
      action: '',
      fileData: {},
      yhid: this.$store.state.userInfo.yhid,
      bjlx: this.$route.query.lx,
      bjid: this.$route.query.classId,
      zhid: this.$store.state.userInfo.zhid,
      group_list: [],
      search_data: {},
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      //   --------------创建分组
      edit_group_obj: {
        type: 1,//1新增 2编辑
        dialogVisible: false,
        title: '新增小组',
        model: {
          mc: '勇往直前',
          rs: 1,
          tx: 'https://wlkt-uc.oss-cn-shanghai.aliyuncs.com/1629342697032_小组头像',
        },
      },
      student_list_tree: [],//可选择学生tree
      default_checked_keys: [],//多选框key
      default_checked: [10, 31],//多选框key
      student_select_list: [],//已经选择学生
      defaultProps: {
        children: "children",
        label: "xsmc",
      },
      // 学生随机分组
      random_group_obj: {
        dialogVisible: false,
        title: '随机分组',
        model: {
          count: 2,
        },
      },
    }
  },
  mounted() {
    this.getGroupList()
    this.handleApp()
    // this.getNoSelectStudents()
  },
  watch: {
    // class_type: function () {
    // }
  },
  methods: {
    getGroupList() {
      const data = this.search_data;
      data.yhid = this.yhid;
      data.bjid = this.bjid;
      data.pageSize = this.pages.pageSize;
      data.currentPage = this.pages.currentPage
      data.startTime = this.$route.query.startTime
      data.endTime = this.$route.query.endTime
      let api
      api = studentGroupListApi;
      if (this.tab_pane_index == 3) {
        api = studentGroupHistoryListApi;
      }
      api(data).then(res => {
        if (res.result) {
          this.pages.total = res.result.total ? res.result.total : 0
          this.group_list = res.result.list;
          this.$emit('groupNumChange', this.pages.total)
        }
      })
    },
    handleSearch() {
      this.pages.currentPage = 1;
      this.getGroupList()
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.handleSearch()
    },
    handleCurrentChange(val) {
      this.pages.currentPage = val;
      this.getGroupList()
    },
    // 从父组件点击的查询
    parentSearch(val) {
      this.search_data.mc = val;
      this.handleSearch()
    },
    // -----------------------------新增和编辑分组

    handleApp() {
      uploadFile().then(res => {
        this.action = res.host
        this.fileData.key = new Date().getTime() + '_小组头像';
        this.fileData.OSSAccessKeyId = res.accessid;
        this.fileData.expire = res.expire;
        this.fileData.policy = res.policy;
        this.fileData.signature = res.signature;
      })

    },
    editGroup(type, result) {
      this.edit_group_obj.type = type;
      this.student_list_tree = [];
      this.default_checked_keys = [];
      this.student_select_list = [];
      if (type == 1) {
        //   新增
        this.edit_group_obj.title = '新增小组';
        this.edit_group_obj.model = {};
      } else if (type == 2) {
        //   编辑
        this.edit_group_obj.title = '编辑小组';
        this.edit_group_obj.model = JSON.parse(JSON.stringify(result));
        this.student_select_list = JSON.parse(JSON.stringify(result.classGroupStudentList))
      }
      // 获取未选择的学生
      this.getNoSelectStudents(type, result)
      this.edit_group_obj.dialogVisible = true
    },
    // 获取未选择学生
    getNoSelectStudents(type, result) {
      const data = {
        bjid: this.bjid,
        yhid: this.yhid,
        startTime: this.$route.query.startTime,
        endTime: this.$route.query.endTime
      }
      studentNoSelectApi(data).then(res => {
        if (res.result) {
          this.student_list_tree = res.result;
          this.student_list_tree.forEach((item => {
            item.xsid = item.id
          }))
          if (type == 2) {
            // 编辑
            // this.getClassGroupStudent(result.id)
            console.log(this.student_select_list)
            this.student_select_list.forEach((item => {
              const obj = {
                xsid: item.xsid,
                xsmc: item.xsmc
              }
              this.student_list_tree.push(obj);
              this.default_checked_keys.push(obj.xsid);
            }))
          }
        }
      })
    },
    // 编辑之前查看班级小组
    // getClassGroupStudent(val) {
    //   const data = {
    //     id: val,
    //     yhid: this.yhid
    //   }
    //   classGroupInforApi(data).then(res => {
    //     this.edit_group_obj.model = res.result;
    //     res.result.classGroupStudentList.forEach((item => {
    //       const obj = {
    //         id: item.id,
    //         xsmc: item.xsmc
    //       }
    //       this.student_list_tree.push(obj);
    //       this.default_checked_keys.push(item.id);
    //     }))
    //     this.student_select_list = res.result.classGroupStudentList;
    //   })
    // },

    handleAvatarSuccess(res, file) {
      this.$set(this.edit_group_obj.model, 'tx', this.action + this.fileData.key)
      console.log(this.edit_group_obj.model.tx)
    },
    beforeAvatarUpload(file) {
      console.log(this.fileData)
      let suffix = file.type
      let suffixArray = ["image/jpg", "image/png", "image/jpeg"]
      if (suffixArray.indexOf(suffix) == -1) {
        this.$message.error('上传头像图片只能是 JPG / PNG 格式!');
        return false
      }
      return suffixArray
    },
    // 点击多选框
    nodeClick(val) {
      // 判断该小组人数已满
      this.Treefilter()
    },
    // 右侧框内删除学生
    handleClose(item, index) {
      const key = this.default_checked_keys.indexOf(item.xsid)
      this.default_checked_keys.splice(key, 1)
      this.student_select_list.splice(index, 1);
    },
    //  筛选有几个已经选中
    Treefilter() {
      this.student_select_list = [];
      this.student_list_tree.forEach((item, index) => {
        if (this.default_checked_keys.indexOf(item.xsid) > -1) {
          this.student_select_list.push(item)
        }
      })
    },
    // 确认小组提交
    submitGroupStudent() {
      // this.edit_group_obj.model.tx = 'https://wlkt-uc.oss-cn-shanghai.aliyuncs.com/1629342697032_小组头像';
      if (!this.edit_group_obj.model.mc) {
        this.$message.error('请填写小组名称')
        return false
      }
      if (!this.edit_group_obj.model.rs) {
        this.$message.error('请填写小组人数')
        return false
      }
      // if (!this.edit_group_obj.model.tx) {
      //   this.$message.error('请上传小组头像')
      //   return false
      // }
      if (this.edit_group_obj.model.rs > this.student_select_list.length) {
        this.$message.error('该小组人数未达到设置的小组人数')
        return false
      }
      if (this.edit_group_obj.model.rs < this.student_select_list.length) {
        this.$message.error('该小组人数超过设置的人数')
        return
      }
      if (this.edit_group_obj.model.mc) {
        if (this.group_list && this.group_list.length > 0) {
          const isDuplicate = this.group_list.some(
              group => group.mc === this.edit_group_obj.model.mc
          );
          //
          // if (isDuplicate) {
          //   this.$message.warning('同一班级的小组名称不能重复！');
          //   return;
          // }
        }
      }
      const data = this.edit_group_obj.model;
      data.bjid = this.bjid;
      data.yhid = this.yhid;
      data.zhid = this.zhid;
      data.classGroupStudentList = this.student_select_list;
      let api
      if (this.edit_group_obj.type == 1) {
        //  新增
        api = creatGroupAddApi;
        data.cjr = this.yhid;
        data.xgr = this.yhid;
        data.sfcgb = this.bjlx == 2 ? 1 : 0
      } else if (this.edit_group_obj.type == 2) {
        //  编辑
        api = creatGroupEditApi;
        data.xgr = this.yhid;
        const arr = JSON.parse(JSON.stringify(this.student_select_list))
        arr.forEach(item => {
          delete item.id
        })
        data.classGroupStudentList = arr;
      }
      api(data).then(res => {
        if (res.success) {
          this.$message.success('分组成功')
          this.handleSearch()
          this.edit_group_obj.dialogVisible = false
        } else {
          this.$message.success(res.resultDesc)
        }
      })
    },
    // --------------------------------随机分组pop
    randomGroup() {
      this.random_group_obj.model.count = 1;
      this.random_group_obj.dialogVisible = true
    },
    // 随机分组提交
    randomGroupSubmit() {
      if (Number(this.random_group_obj.model.rs) <= 0) {
        this.$message.error('请确定分组个数')
      }
      const data = {
        count: Number(this.random_group_obj.model.count),
        yhid: this.yhid,
        bjid: this.bjid,
        cjr: this.yhid,
        xgr: this.yhid,
        zhid: this.zhid,
        sfcgb: this.bjlx == 2 ? 1 : 0,
        startTime: this.$route.query.startTime,
        endTime: this.$route.query.endTime,
      }
      creatGroupGandomApi(data).then(res => {
        if (res.success) {
          this.$message.success('分组成功')
          this.handleSearch()
          this.random_group_obj.dialogVisible = false
        } else {
          this.$message.warning(res.resultDesc)
        }
      })

    },
    // ----------------------------------------删除小组
    delGroup(val) {
      this.$confirm('此操作将删除该小组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        classGroupDelApi({ id: val.id, yhid: this.yhid }).then(res => {
          this.getGroupList()
          this.$message.success('删除成功')
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.group-box {
  height: 100%;
}
.tea-group {
  height: 100%;
}
.group-main {
  height: calc(100% - 45px);
  overflow-y: auto;
}
.group-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  ::v-deep  .box-card {
    width: 360px;
    margin: 8px;
    font-size: 14px;
  }
  ::v-deep .el-card__body {
    padding: 0;
  }
  .card-main {
    padding: 20px;
    .group-name {
      display: flex;
      align-items: center;
    }
    .group-num {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 10px 0;
    }
    .group-people {
      display: flex;
      align-items: flex-start;
      margin-top: 10px;
    }
    .group-name-img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }

  .card-btn {
    width: 100%;
    height: 40px;
    background-color: #f1f1f1;
    display: flex;
    width: 100%;
    align-items: center;
    .btn {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 25px;
    }
    .btn:first-child {
      border-right: #67c23a solid 1px;
    }
  }
}
.tea-pagination {
  margin-top: 15px;
}
.header-box {
  width: 40px;
  height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 50%;
  .el-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}
.is-full {
  span {
    font-size: 12px;
    color: #f56c6c;
  }
}
.select-box {
  width: 100%;
  display: flex;
  align-items: center;
  ::v-deep .el-card__header {
    padding: 0px 20px;
  }
  ::v-deep .el-card__body {
    padding: 10px 20px;
    height: calc(100% - 40px);
    overflow-y: scroll;
  }
  .student-list {
    width: 200px;
    height: 300px;
    border: #eee solid 1px;
    ::v-deep .el-checkbox-group {
      display: flex;
      flex-direction: column;
    }
  }
  .student-select {
    width: 300px;
    height: 300px;
    border: #eee solid 1px;
    margin-left: 40px;
    .el-tag {
      margin: 0 5px;
    }
  }
}
</style>
